module.exports = __webpack_public_path__ + "static/media/video.0892d9b5.png";